import { useQuery } from "@connectrpc/connect-query";
import { exploreStats } from "@uniswap/client-explore/dist/uniswap/explore/v1/service-ExploreStatsService_connectquery";
import { uniswapGetTransport } from "uniswap/src/data/rest/base";
export function useExploreStatsQuery(input) {
  return useQuery(exploreStats, input, { transport: uniswapGetTransport, staleTime: 60 * 60 * 1e3 });
}
